/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// Validation
define('global/Validation',[
    'jquery',
    'lodash',
    './UI/all',
    './CreditCard',
    './EventBuilder',
    './EventManager',
    './Constants',
    './Logger'
], function ($, _, UI, CreditCard, EventBuilder, EventManager, Constants, Logger) {
    'use strict';

    function checkRequredValidator(f) {
        var $field = $(f.Field);
        var validationResult = true;
        switch (f.Type) {
            case 'Text':
            case 'Textarea':
                var val = $field.val();
                if (val !== undefined && val !== null) {
                    $field.val($.trim(val)); // remove leading and trailing whitespaces before validation
                }
                if ($field.is(':visible')) {
                    if (!$field.val() || $field.val() === '') {
                        validationResult = false;
                    }
                }
                break;
            case 'Select':
            case 'Range':
                if ($field.is(':visible')) {
                    if (!$field.val() || $field.val() === '') {
                        validationResult = false;
                    }
                }
                break;
            case 'Rating':
                if (!$field.val() || $field.val() === '0') {
                    validationResult = false;
                }
                break;
            case 'Checkbox':
            case 'Radio':
                if (!$field.is(':checked')) {
                    validationResult = false;
                }
                break;
            case 'Hidden':
                if (!$field.val() || $field.val() === '') {
                    validationResult = false;
                }
                break;
            case 'Checkboxlist':
            case 'Radiolist':
                if (!f.Optional) {
                    var valid = false;
                    $field.find('input').each(function (indx, elem) {
                        if ($(this).is(':checked')) {
                            valid = true;
                            return false;
                        }
                        return true;
                    });
                    validationResult = valid;
                }
                break;
        }

        return validationResult;
    }

    function validateField(f, displayErrors) {
        if (displayErrors === undefined) {
            displayErrors = true;
        }

        var $field = $(f.Field);
        var validationResult = true;
        if (!f.Optional) {
            validationResult = checkRequredValidator(f);
        }

        if (!validationResult && f.ExcludeFromErrorSummary !== true) {
            f.ErrorMsg = '"' + f.Name + '" is required';
        }
        else {
            delete f.ErrorMsg;
        }

        if (validationResult) { // check Validators only if it is in valid state
            if (f.Validators) {
                _.forEach(f.Validators, function (v) {
                    var fieldVal = validationResult;
                    switch (v.Type) {
                        case 'Zip':
                            if (v.ReferencedField) {
                                var $countryRefField = $(v.ReferencedField);
                                if (v.ReferencedFieldAttr && v.ReferencedValue && v.ReferencedFieldType) {
                                    switch (v.ReferencedFieldType.toLowerCase()) {
                                        case 'select':
                                            // if it is not conditionally required and value is empty then stop here
                                            if ($countryRefField.find('option:selected').attr(v.ReferencedFieldAttr) !== v.ReferencedValue && $field.val().length === 0) {
                                                return;
                                            }
                                            break;
                                    }
                                }

                                if ($countryRefField.val() === 'US') {
                                    // Country is US, check if there is '-' in value
                                    if ($field.val().indexOf('-', 0) === -1) {
                                        // No '-' in value, check length to be 5
                                        fieldVal = /^(\+|\-)?([0-9]+)$/.test($.trim($field.val()));
                                        if (fieldVal) {
                                            fieldVal = $.trim($field.val()).length === 5;
                                        }
                                    } else {
                                        // "-" is in value, check length before (5) and after "-" (4)
                                        var ary = $.trim($field.val()).split('-');
                                        fieldVal = /^(\+|\-)?([0-9]+)$/.test(ary[0]);

                                        if (fieldVal) {
                                            fieldVal = /^(\+|\-)?([0-9]+)$/.test(ary[1]);
                                        }

                                        if (fieldVal) {
                                            fieldVal = ary[0].length === 5;
                                        }

                                        if (fieldVal) {
                                            fieldVal = ary[1].length === 4;
                                        }
                                    }
                                } else {
                                    fieldVal = $field.val().length > 0; // country is not US, check if any value
                                }
                            } else {
                                fieldVal = $field.val().length > 0; // no referenced country field, check if any value
                            }
                            break;
                        case 'Integer':
                            fieldVal = /^(\+|\-)?([0-9]+)$/.test($field.val());
                            break;
                        case 'Length':
                            fieldVal = $field.val().length === v.Value;
                            break;
                        case 'MinValue':
                            fieldVal = parseFloat($field.val()) >= v.Value;
                            break;
                        case 'MaxValue':
                            fieldVal = parseFloat($field.val()) <= v.Value;
                            break;
                        case 'Email':
                            fieldVal = /^[A-Za-z0-9']([\.\-\+]?[a-zA-Z0-9'_])*\@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,5}$/.test($field.val());
                            break;
                        case 'WhiteSpace':
                            fieldVal = /[^\s]/.test($field.val());
                            break;
                        case 'CCType':
                            var cctype = $field.find("[value='" + $field.val() + "']").text();
                            var ccnum = $('#' + v.CardNumberField).val();
                            fieldVal = CreditCard.validateCCType(cctype, ccnum);
                            break;

                        case 'CCNum':
                            fieldVal = CreditCard.validateCCNum($field.val());
                            break;

                        case 'CVV':
                            var cardType;
                            if (typeof v.CardTypeField != 'undefined') {
                                cardType = $(v.CardTypeField).val();
                            } else if (typeof v.CardNumField != 'undefined') {
                                cardType = CreditCard.detectCreditCardType($(v.CardNumField).val());
                            }

                            var cvv = $field.val();
                            fieldVal = (cardType !== null && cardType.length > 0) ? CreditCard.validateCvvCode(cardType, cvv) : false;
                            break;
                        case 'ConfirmField':
                            var originFieldValue;
                            if (typeof v.OriginField != 'undefined') {
                                originFieldValue = $(v.OriginField).val();
                            }
                            var confirmFiled = $field.val();
                            fieldVal = originFieldValue === confirmFiled;
                            f.ErrorMsg = v.ErrorMsg;
                            break;

                        case 'RequiredIfField':

                            var conditionalFieldValue;
                            if (typeof v.ConditionalField != 'undefined') {
                                var $ConditionalField = $(v.ConditionalField);
                                switch (v.ConditionalFieldType) {
                                    case 'Checkbox':
                                    case 'Radio':
                                        conditionalFieldValue = $ConditionalField.is(':checked');
                                        break;
                                    case 'Select':
                                        conditionalFieldValue = $ConditionalField.find('option:selected').attr(v.ConditionalFieldAttr);
                                        break;
                                    default:
                                        conditionalFieldValue = $ConditionalField.val();
                                        break;
                                }

                                if (v.ConditionalValue === conditionalFieldValue) {
                                    if (!checkRequredValidator(f)) {
                                        fieldVal = false;
                                        if (v.ErrorMsg) {
                                            f.ErrorMsg = v.ErrorMsg;
                                        } else {
                                            f.ErrorMsg = '"' + f.Name + '" is required';
                                        }
                                    }
                                }
                            }

                            break;

                        case 'Custom':
                            if (v && typeof v.fn === 'function') {
                                fieldVal = v.fn($field.val());
                            } else {
                                console.warn('fn: ' + v.fn + ' not found');
                                fieldVal = false;
                            }
                            break;

                        default:
                            fieldVal = true;
                    }

                    if (!fieldVal) {
                        validationResult = false;
                    }

                    if (!validationResult && f.ExcludeFromErrorSummary !== true) {
                        if (!f.ErrorMsg) {
                            f.ErrorMsg = '"' + f.Name + '" is not valid';
                        }
                    }
                    else {
                        delete f.ErrorMsg;
                    }
                });
            }
        }

        if (displayErrors && !validationResult) {
            UI.showFormFieldError(f);
        }

        return validationResult;
    }

    function bindGlobalEvents() {
        EventManager.bind(Constants.events.templates.RENDER_FORM_COMPLETED, function (result) {
            $.each($(result.outputContainer.selector+" .formee-req"), function () {
                var asteriskContainer = $(this);
                var conditionalRequiredField = asteriskContainer.attr('data-conditionalField');
                var conditionalRequiredFieldType = asteriskContainer.attr('data-conditionalFieldType');
                var conditionalRequiredFieldAttr = asteriskContainer.attr('data-conditionalFieldAttr');
                var conditionalRequiredValue = asteriskContainer.attr('data-conditionalValue');

                if (conditionalRequiredField && conditionalRequiredFieldType && conditionalRequiredValue) {
                    var changeEventNamespace = '.validation-bindGlobalEvents';
                    var changeEventArray = ['change', Constants.events.general.CHANGE];
                    var eventName = EventBuilder.buildName(changeEventArray, changeEventNamespace);
                    UI.attachEventHandler(eventName, conditionalRequiredField, function () {
                            var shouldRequireSpanBeVisible = false;
                            switch (conditionalRequiredFieldType.toLowerCase()) {
                            case 'select':
                                shouldRequireSpanBeVisible = $(conditionalRequiredField).find('option:selected').attr(conditionalRequiredFieldAttr) === conditionalRequiredValue;
                                break;
                            }

                            if (shouldRequireSpanBeVisible) {
                                asteriskContainer.show();
                            } else {
                                asteriskContainer.hide();
                            }
                        });

                    //triggering change event to set initial asterisk's visibility
                    $(conditionalRequiredField).trigger((changeEventArray[0] + changeEventNamespace));
                }
            });
        });
    }

    function validateForm(form, displayErrors, displayErrorSummary) {
        if (typeof displayErrors == 'undefined') {
            displayErrors = true;
        }
        if (typeof displayErrorSummary == 'undefined') {
            displayErrorSummary = true;
        }

        var validationResult = true;
        var focusFirstFieldOnError = true;

        if (typeof(form) === 'object' && form.Validate) {
            UI.clearFormErrors(form);

            _(form.Fields).forEach(function (f) {
                if (!validateField(f, displayErrors)) {
                    validationResult = false;
                    if (focusFirstFieldOnError && f.Type !== 'Hidden') {
                        $(f.Field).focus();
                        focusFirstFieldOnError = false;
                    }
                };
            });

            if (displayErrorSummary) {
                UI.showFormErrorSummary(form);
            }
        }
        return validationResult;
    }

    function validate(forms, displayErrors) {
        if (typeof displayErrors == 'undefined') {
            displayErrors = true;
        }

        var groupValidationResult = true;
        _.forIn(forms, function (k, i) {
            var result = true;
            if (k.isGroup) {
                result = validate(k, displayErrors);
            } else if(typeof (k) === "object") {
                result = validateForm(k, displayErrors);
            }

            if (!result) {
                groupValidationResult = false;
            }
        });

        return groupValidationResult;
    }

    function getField(form, fieldFullName) {
        if (form && form.Fields) {
            return _.find(form.Fields, function (f) {
                return f.Name === fieldFullName;
            });
        }
        return null;
    }

    function getFieldValues(form) {
        var values = {};
        _.forEach(form.Fields, function (f) {
            if (f.Param !== undefined) {
                if (f.Type === "Checkbox") {
                    values[f.Param] = $(f.Field).is(':checked');
                } else {
                    values[f.Param] = $(f.Field).val();
                };
            }
        });
        return values;
    }

    /**
     * Returns an object with valid fields(as properties fieldName: fieldValue) for the specified form
     * @param {} form 
     * @returns {} 
     */
    function getValidFieldValues(form) {
        var result = {};
        var fieldValues = getFieldValues(form);

        _(form.Fields).forEach(function (f) {
            if (validateField(f, false) && _.has(fieldValues, f.Param)) {
                result[f.Param] = fieldValues[f.Param];
            };
        });
        return result;
    };

    /**
     * Disables form validation (supports group form definition)
     * @param {} form 
     * @returns {} 
     */
    function disableFormValidation(form) {
        if (form.isGroup) {
            _.forIn(form, function (subForm) {
                if (typeof (subForm) === 'object') {
                    subForm.Validate = false;
                }
            });
        } else {
            form.Validate = false;
        }
    }


    var Validation = {
        bindGlobalEvents: bindGlobalEvents,
        validateForm: validateForm,
        validate: validate,
        getField: getField,
        getFieldValues: getFieldValues,
        getValidFieldValues: getValidFieldValues,
        disableFormValidation: disableFormValidation
    };

    Logger.debug('Validation.js Loaded:', Validation);

    return Validation;
});
